import { FoodsTooltip, Typography } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import type { AuditLogEntry } from "src/api/client-api/auditLog/auditLogSchemas";
import { auditLogScopeLabel } from "./auditLogPresentation";

type CellProps = {
    entry: AuditLogEntry;
};

export const AuditLogScopeLabel = (props: CellProps) => {
    const { entry } = props;
    const { t } = useTranslation();
    const scope = auditLogScopeLabel(entry);

    if (scope === null) {
        return (
            <Typography variant="small-regular" color="text.secondary" fontStyle="italic" noWrap>
                {t("settings.audit_log.scope_type.platform", "Platform")}
            </Typography>
        );
    }

    return (
        <Typography variant="small-regular" noWrap>
            {scope}
        </Typography>
    );
};

export const AuditLogIpLabel = (props: CellProps) => {
    const { entry } = props;

    if (entry.ip === null) {
        return (
            <Typography variant="small-regular" color="text.secondary">
                {"—"}
            </Typography>
        );
    }

    if (entry.requestId === null) {
        return (
            <Typography variant="small-regular" noWrap>
                {entry.ip}
            </Typography>
        );
    }

    return (
        <FoodsTooltip title={`request_id ${entry.requestId}`}>
            <Typography variant="small-regular" noWrap>
                {entry.ip}
            </Typography>
        </FoodsTooltip>
    );
};
